export interface CampaignExportDelivery {
    guid: string;
    delivery_type: 'scheduled' | 'manual';
    scheduled_for: string | null;
    status: 'sending' | 'sent' | 'failed';
    attempts: number;
    error: string | null;
    created: string;
    modified: string | null;
}

const isDateTime = (value: unknown) =>
    typeof value === 'string' && Number.isFinite(Date.parse(value));

const isCampaignExportDelivery = (value: unknown): value is CampaignExportDelivery => {
    if (!value || typeof value !== 'object') return false;
    return (
        'guid' in value &&
        typeof value.guid === 'string' &&
        'delivery_type' in value &&
        ['scheduled', 'manual'].includes(String(value.delivery_type)) &&
        'scheduled_for' in value &&
        (value.scheduled_for == null || isDateTime(value.scheduled_for)) &&
        'status' in value &&
        ['sending', 'sent', 'failed'].includes(String(value.status)) &&
        'attempts' in value &&
        typeof value.attempts === 'number' &&
        Number.isInteger(value.attempts) &&
        value.attempts > 0 &&
        'error' in value &&
        (value.error == null || typeof value.error === 'string') &&
        'created' in value &&
        isDateTime(value.created) &&
        'modified' in value &&
        (value.modified == null || isDateTime(value.modified))
    );
};

export const parseCampaignExportDeliveries = (data: unknown): CampaignExportDelivery[] => {
    if (!Array.isArray(data) || !data.every(isCampaignExportDelivery)) {
        throw new Error('Invalid campaign export delivery data');
    }
    return data;
};
